import './TopBars.css'
// import NavBar from './NavBar.jsx';
import PrincipalBar from './principalBar/PrincipalBar'

function TopBars() {
    return <div className='top_bars'>
        <PrincipalBar />
    </div>
}
export default TopBars;
